import { useTranslation } from 'react-i18next';
import type { TranslationNamespace } from '../types/namespace';

export const useTranslatedContent = (namespace: TranslationNamespace | TranslationNamespace[]) => {
  const { t, i18n } = useTranslation(namespace);
  
  return {
    t,
    currentLanguage: i18n.language,
    changeLanguage: i18n.changeLanguage,
    isRTL: i18n.dir() === 'rtl'
  };
};